import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import swal from 'sweetalert';
import { bindActionCreators } from 'redux';
import { push } from 'connected-react-router';

import * as loginActions from '../redux/login';
import MobileWindow from './Wrappers/MobileWindow';
import billing from '../svg/plan-payment.svg';
import results from '../svg/results.svg';
import logout from '../svg/logout.svg';
import './Dashboard.css';

const Link = styled.div`
  background-color: var(--color-beige);
  width: 50px;
  height: 50px;
  margin: auto;
  border-radius: 8px;
  margin-right: 15px;
  display: inline-block;
`;

interface Props {
  login: any;
  business: any;
  goTo: any;
}

interface State {}

class MobileDashboard extends React.Component<Props, State> {
  logout() {
    swal('Are you sure you want to logout?', {
      buttons: [true, true],
    }).then((result) => {
      if (result) this.props.login.logout();
    });
  }

  render() {
    return (
      <MobileWindow page="dashboard">
        <div
          style={{
            margin: '50px',
            fontFamily: 'BrandonGrotesque-Regular',
            color: 'var(--color-beige)',
            marginBottom: '35px',
          }}
        >
          <img src={"/img/logo@3x.png"} alt="logo" style={{ margin: 'auto', display: 'block' }} />
          <div style={{ fontSize: '50px', marginTop: '20px' }}>Welcome,</div>
          <div style={{ fontSize: '30px' }}>{this.props.business.name}</div>
          <br />
          <div style={{ fontSize: '18px', color: 'white' }}>
            Neon Coat is fully customizable in order to provide you with the best experience. Use
            the quick-links below to get started!
          </div>
        </div>
        <div style={{ marginLeft: '50px' }}>
          <Link>
            <img
              alt="results"
              src={results}
              className="mobile-dashboard-icon"
              onClick={() => this.props.goTo('/instagram')}
            />
          </Link>
          <Link>
            <img
              alt="billing"
              src={billing}
              className="mobile-dashboard-icon"
              onClick={() => this.props.goTo('/billing')}
            />
          </Link>
          <Link>
            <img
              alt="logout"
              src={logout}
              className="mobile-dashboard-icon"
              onClick={() => this.logout()}
            />
          </Link>
        </div>
      </MobileWindow>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    data: state.monthly,
    business: state.business,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    goTo: (url: string) => dispatch(push(url)),
    login: bindActionCreators(loginActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileDashboard);
